const words = [
  "Independent Film",
  "Short Form",
  "Bay Area Made",
  "Festival Circuit",
  "No Budget",
  "All Heart",
  "Shot on Location",
];

export default function Marquee() {
  const loop = [...words, ...words];

  return (
    <section className="w-full bg-background-200/70 py-6 overflow-hidden border-y border-background-300/60">
      <div className="flex w-max animate-marquee-x">
        {loop.map((word, index) => (
          <span key={`${word}-${index}`} className="flex items-center">
            <span className="font-heading text-xl md:text-3xl font-semibold text-foreground-400 px-6 whitespace-nowrap">
              {word}
            </span>
            <span className="w-6 h-6 flex items-center justify-center text-primary-500">
              <i className="ri-film-line text-lg"></i>
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}